<template>
  <div class="Melamine">
    <div class="title">Acetone</div>
    <div class="item-huanhang">
      <label>Product Description:</label>
      <p>
        Acetone is clear, colorless, low boiling, flammable, volatile liquid,
        characterized by rapid evaporation and a faintly aromatic, sweetish
        odor. It is readily miscible in most organic solvents and completely
        miscible, in all proportions, in distilled water.
      </p>
    </div>
    <div class="table">
      <el-table border :data="tableData" stripe>
        <el-table-column prop="ITEMS" label="ITEMS" width="280">
        </el-table-column>
        <el-table-column prop="UNIT" label="UNIT"> </el-table-column>
        <el-table-column prop="INDEX" label="INDEX" width="280">
        </el-table-column>
        <!-- <el-table-column prop="RESULTS" label="RESULTS"> </el-table-column> -->
      </el-table>
    </div>
    <div class="item">
      <label>Packaging:</label>
      <p>in 160kg net drums or in isotanks.</p>
    </div>
    <div class="item-huanhang">
      <label>Applications:</label>
      <p>
        It is widely used as a chemical intermediate in the production of
        nnethyl isobutyl ketone and other solvents, and in the production of
        such important chemicals as bisphenol A and methyl methacrylate It is
        also used in the manufacture of a wide variety of copatings and plastics
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          ITEMS: "Appearance",
          UNIT: "",
          INDEX: "colorless & transparent liquid",
          RESULTS: "pass",
        },
        { ITEMS: "Purity", UNIT: "wt.%", INDEX: "99.5min", RESULTS: " 99.8" },
        {
          ITEMS: "Water content ",
          UNIT: "wt.% ",
          INDEX: "0.3max",
          RESULTS: "0.16",
        },
        {
          ITEMS: "Distillation range,(0℃,101.3kPA)include 56.1",
          UNIT: " ℃ ",
          INDEX: "0.7max",
          RESULTS: "0.3",
        },
        {
          ITEMS: "Density, 20°C",
          UNIT: " g cm3 ",
          INDEX: "0.789~0.791",
          RESULTS: "0.79",
        },
        { ITEMS: "Color.Pt/Co.", UNIT: "", INDEX: "5max", RESULTS: "4" },
        {
          ITEMS: "Acidity, as acetic acid, ",
          UNIT: "wt.%",
          INDEX: "0.002max",
          RESULTS: "0.001",
        },
        {
          ITEMS: "Ethanol content",
          UNIT: "wt.% ",
          INDEX: "0.2max",
          RESULTS: "0.100",
        },
        {
          ITEMS: "Evaporation residue",
          UNIT: " % (m.m)",
          INDEX: "0.003max",
          RESULTS: "0.002",
        },
        {
          ITEMS: "Permanganate time test, @ 25°C, ",
          UNIT: "minutes",
          INDEX: "120min",
          RESULTS: "150",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  .title {
    font-size: 30px;
    height: 50px;
    line-height: 50px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
  }
  .item {
    display: flex;
    height: 40px;
    line-height: 40px;
    column-gap: 20px;
    label {
      font-size: 20px;
      font-weight: bold;
    }
    p {
      color: gray;
      font-weight: bold;
    }
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
    label {
      font-size: 20px;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
    }
    p {
      color: gray;
      line-height: 30px;
      font-weight: bold;
    }
  }
}
</style>
